import React from 'react';
import {
    Select, FormControl, MenuItem, InputLabel,
} from '@mui/material';

/**
 * @typedef {{value: string | number; label: string;}} MenuItemProps
 *
 * @typedef {Object} FormSelectProps
 * @property {string} name
 * @property {MenuItemProps[]} options
 * @property {Function} [onChange]
 * @property {boolean} [disabled]
 * @property {import('@mui/material').MenuProps} [MenuProps]
 * @property {import('react-hook-form').RegisterOptions} [rules]
 * @property {*} control
 * @property {string} [variant]
 * @property {string} [inputLabelText]
 */


/**
 * A custom select component.
 * 
 * @param {Object} param0
 * @param {import('@mui/material').SelectProps} param0.props - Props for the MUI Select component.
 * @param {React.Ref<HTMLSelectElement>} [param0.ref] - The ref to forward to the underlying Select component.
 * @param {string} [param0.customProp] - An example custom prop.
 * @returns {JSX.Element}
 */
const SelectCustom = React.forwardRef(({
    name,
    disabled: isDisabled = false,
    MenuProps: CustomMenuProps,
    options,
    variant = 'outlined',
    inputLabelText,
    ...props
}, ref) => (
    <FormControl disabled={isDisabled}>
        {!!inputLabelText && (<InputLabel>{inputLabelText}</InputLabel>)}
        <Select
            ref={ref}
            MenuProps={CustomMenuProps || {
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
                //getContentAnchorEl: null,
            }}
            inputProps={{ readOnly: isDisabled }}
            variant={variant}
            {...props}
        >
            {
                options?.map((/** @type MenuItemProps */option) => (
                    <MenuItem
                        key={`menu-item-${option.value.toString()}`}
                        value={option.value}
                    >
                        {option.label}
                    </MenuItem>
                ))
            }
        </Select>
    </FormControl>
));

export default SelectCustom;
